import * as React from 'react';

import { HELP_ARTICLE_LINKS } from '@showbie-socrative/socrative-utils/lib/consts/constants';
import { translate } from '~l10n/client';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { AlertMessage } from '~shared/components/AlertMessage';

export const isNotificationAtomVisible = atomWithStorage<boolean>(
  '__protip-rooms',
  true
);
interface Props {
  hasRosters: boolean;
}

export function RoomsProTipBar({ hasRosters }: Props) {
  const [isVisible, setIsVisible] = useAtom(isNotificationAtomVisible);

  if (!isVisible || hasRosters) {
    return null;
  }

  return (
    <div data-testid="rooms-pro-tip" className="pb-10">
      <AlertMessage
        closeLabel={translate('Close')}
        onClose={() => {
          setIsVisible(false);
        }}
        showIcon
        tone="info"
      >
        <span
          dangerouslySetInnerHTML={{
            __html:
              translate(
                `<strong>Pro tip:</strong> Create a rostered room to email students their results and manage student access.`
              ) + ' ',
          }}
        />
        <a
          className="alert-message__link"
          href={HELP_ARTICLE_LINKS.MANAGE_ROOMS_AND_ROSTERS}
          target="_blank"
          rel="noopener noreferrer"
        >
          {translate('Learn More')}
        </a>
      </AlertMessage>
    </div>
  );
}
